import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import '../ri-ev-medico-search.scss';
import { Grid } from '@mui/material';
import { SelectInput } from '../../../components/selectInput/SelectInput';

import { CustomButton } from '../../../components/customButton/CustomButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckIcon from '@mui/icons-material/Check';
import moment from 'moment';
import 'moment/locale/es';

import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_PROFESIONALES_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getProfesionalesRIEV';
import { GET_PACIENTES_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getPacientesRIEV';
import { GET_EVALUACIONES_RI_EV } from '../../../data/graphQL/queries/RiEvMedico/getEvaluacionesRIEV';
import { DELETE_RI_EV } from '../../../data/graphQL/mutations/RiEvMedico/delete';

import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { adaptProfesionalArray } from '../../../adapters/profesionalAdapter';
import { adaptPacienteArray } from '../../../adapters/pacienteAdapter';
import toast from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { downloadExcel } from '../../../utils/downloadExcel';

export default function RiEvMedicoCons({ setChildrenAction }) {

  const storageId = sessionStorage.getItem('idUsuario');

  const header = ["#", "Profesional", "HC", "Paciente", "Contrato", "Formulario", "Digitalizado", "Digital"];

  const FILE_TYPE = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  const [delegaciones, setDelegaciones] = useState([]);
  const [profesionales, setProfesionales] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [openDlg, setOpenDlg] = useState(false);
  const [textoEliminacion, setTextoEliminacion] = useState(0);
  const [idEliminacion, setIdEliminacion] = useState(0);
  const [idEliminacionEvolucion, setIdEliminacionEvolucion] = useState(0);
  const [dataExport, setDataExport] = useState([]);

  const [figurasMedico] = useState([
    { id: 1, displayName: 'Seguimiento' },
    { id: 3, displayName: 'Evaluador' }]
  );
  const [digitalizaciones] = useState([
    { id: "2", displayName: 'TODOS' },
    { id: "1", displayName: 'Si' },
    { id: "0", displayName: 'No' }]
  );
  const [meses] = useState(
    [
      { id: 1, displayName: 'Enero' }, { id: 2, displayName: 'Febrero' }, { id: 3, displayName: 'Marzo' },
      { id: 4, displayName: 'Abril' }, { id: 5, displayName: 'Mayo' }, { id: 6, displayName: 'Junio' },
      { id: 7, displayName: 'Julio' }, { id: 8, displayName: 'Agosto' }, { id: 9, displayName: 'Septiembre' },
      { id: 10, displayName: 'Octubre' }, { id: 11, displayName: 'Noviembre' }, { id: 12, displayName: 'Diciembre' }]

  );
  const currentYear = parseInt(moment().format('YYYY'), 10);
  const currentMonth = parseInt(moment().format('MM'), 10);
  let anios = [];
  for (var i = currentYear - 10; i <= currentYear; i++) {
    anios.push({ id: i, displayName: i });
  }

  const initialState = {
    mes: currentMonth - 1,
    anio: currentYear,
    delegacion: 0,
    digitalizado: "2",
    figuraMedico: 0,
    profesional: 0,
    paciente: 0,
    idServicio: 1
  };

  const [dataCons, setDataCons] = useState(initialState);

  useEffect(() => {
    setChildrenAction(() =>
      <div style={{ width: '231px' }}>
        <CustomButton
          onClick={handleExportar}
          size='small'
          variant='contained'>
          Descargar consulta
        </CustomButton>
      </div>
    );
  }, [setChildrenAction, dataExport]);

  const handleExportar = () => {
    if (dataExport.length > 0) {
      downloadExcel({
        fileName: 'VisitasProfesionales',
        sheet: "RI-EV Médico",
        tablePayload: {
          header,
          body: dataExport
        }
      });
    }
  };

  useEffect(() => {
    for (var i = 0; i < evaluaciones.length; i++) {
      let nodo = evaluaciones[i];
      dataExport.push({
        idProfesional: nodo.idProfesional,
        profesional: nodo.profesional,
        hc: nodo.idPaciente,
        paciente: nodo.paciente,
        contrato: nodo.contrato,
        formulario: nodo.formulario,
        digitalizado: nodo.digitalizado,
        digital: nodo.digital ? "SI" : "NO"
      });
    }
  }, [evaluaciones]);

  const [getDelegaciones, { loading: delegacionesLoading, data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionesData) return;

    setDelegaciones(adaptDelegacionArray(delegacionesData));
    if (delegacionesData.allDelegacionesByUsuario[0].idDelegacion > 0) {
      setDataCons((previousData) => ({
        ...previousData,
        delegacion: delegacionesData.allDelegacionesByUsuario[0].idDelegacion
      }));
    }
  }, [delegacionesData]);

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId, 10) } });
    }
  }, [storageId]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setDataCons((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  useEffect(() => {
    if (dataCons.figuraMedico > 0) {
      buscarProfesionales();
    }
  }, [dataCons.delegacion, dataCons.mes, dataCons.anio, dataCons.figuraMedico]);

  const buscarProfesionales = () => {
    setProfesionales([]);
    setPacientes([]);
    setDataCons((previousData) => ({
      ...previousData,
      profesional: 0,
      paciente: 0
    }));

    getProfesionales({
      variables: {
        filter: {
          idDelegacion: dataCons.delegacion,
          idTipoProfesional: dataCons.figuraMedico,
          mes: dataCons.mes,
          anio: dataCons.anio
        }
      }
    });
  };

  const [getProfesionales, { loading: profesionalesLoading, data: profesionalesData }] = useLazyQuery(GET_PROFESIONALES_RI_EV, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!profesionalesData) return;

    if (profesionalesData.profesionalesRIEV.success) {
      if (profesionalesData.profesionalesRIEV.valorEsperado.length == 0) {
        setProfesionales([]);
        setPacientes([]);
        setDataCons((previousData) => ({
          ...previousData,
          profesional: 0,
          paciente: 0
        }));
      } else {
        setProfesionales(adaptProfesionalArray(profesionalesData));
      }
    } else {
      toast.error("No fue posible consultar los profesionales.");
    }
  }, [profesionalesData]);

  useEffect(() => {
    setDataCons((previousData) => ({
      ...previousData,
      paciente: 0
    }));

    if (dataCons?.profesional > 0) {
      getPacientes({
        variables: {
          filter: {
            idDelegacion: dataCons.delegacion,
            idTipoProfesional: dataCons.figuraMedico,
            mes: dataCons.mes,
            anio: dataCons.anio,
            idProfesional: dataCons.profesional
          }
        }
      });
    } else {
      setPacientes([]);
    }
  }, [dataCons?.profesional]);

  const [getPacientes, { loading: pacientesLoading, data: pacientesData }] = useLazyQuery(GET_PACIENTES_RI_EV, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!pacientesData) return;

    setPacientes(adaptPacienteArray(pacientesData));
  }, [pacientesData]);

  const handleBuscar = () => {
    getEvaluaciones({
      variables: {
        filter: {
          idDelegacion: dataCons.delegacion,
          idFiguraProfesional: dataCons.figuraMedico,
          mes: dataCons.mes,
          anio: dataCons.anio,
          digitalizado: parseInt(dataCons.digitalizado, 10),
          idServicio: dataCons.figuraMedico,
          idProfesional: dataCons.profesional,
          idPaciente: dataCons.paciente
        }
      }
    });
  };

  const [getEvaluaciones, { loading: evaluacionesLoading, data: evaluacionesData }] = useLazyQuery(GET_EVALUACIONES_RI_EV, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!evaluacionesData) return;

    if (evaluacionesData.evaluacionesRIEV?.success) {
      setDataExport([]);
      setEvaluaciones(evaluacionesData.evaluacionesRIEV.valorEsperado);
    } else {
      toast.error("No fue posible consultar las evaluaciones.");
    }
  }, [evaluacionesData]);

  const handleDelete = (row) => {
    setTextoEliminacion("¿Está seguro de eliminar la EV/RI del profesional " + row.profesional + " para el paciente " + row.paciente + "?");
    setOpenDlg(true);
    setIdEliminacion(row.idEvaluacion);
    setIdEliminacionEvolucion(row.idEvolucionRIMedico);
  };

  const initialColumnsProcesamiento = [
    {
      headerName: '',
      field: 'action',
      flex: 0.05,
      renderCell: ({ row }) => {
        return (
          <div className='acciones'>
            {
              <div onClick={() => handleDelete(row)} aria-hidden='true' style={{ paddingTop: '7px' }}>
                <DeleteOutlineIcon className='edit-icon' />
              </div>
            }
          </div>);

      }
    },
    {
      field: 'idProfesional',
      headerName: '#',
      flex: 0.05
    },
    {
      field: 'profesional',
      headerName: 'Profesional',
      flex: 0.2
    },
    {
      field: 'idPaciente',
      headerName: 'HC',
      flex: 0.08
    },
    {
      field: 'paciente',
      headerName: 'Paciente',
      flex: 0.2
    },
    {
      field: 'contrato',
      headerName: 'Contrato',
      flex: 0.3
    },
    {
      field: 'formulario',
      headerName: 'Formulario',
      flex: 0.1
    },
    {
      field: 'digitalizado',
      headerName: 'Digitalizado',
      align: 'center',
      flex: 0.1,
      valueGetter: (digitalizado) => {
        return digitalizado == "SI" ? <CheckIcon className="icon" /> : "";
      }
    },
    {
      field: 'digital',
      headerName: 'Digital',
      align: 'center',
      flex: 0.08,
      valueGetter: (digital) => {
        return digital == "SI" ? <CheckIcon className="icon" /> : "";
      }
    }];


  const columnsProcesamiento = generateColumnsDefaultConfiguration(initialColumnsProcesamiento);

  const handleAceptarDlg = () => {
    const nodo = evaluaciones.filter((e) => e.idEvaluacion == idEliminacion);
    if (nodo.length > 0 && nodo[0] != null) {
      const params = {
        mes: dataCons.mes,
        anio: dataCons.anio,
        idFiguraProfesional: dataCons.figuraMedico,
        idProfesional: nodo[0].idProfesional,
        idEvaluacion: idEliminacion,
        idEvolucion: idEliminacionEvolucion
      };

      deleteEv({ variables: { data: params } });
    }
  };

  const [deleteEv, { error: deleteError }] = useMutation(DELETE_RI_EV, {
    onCompleted: (deleteData) => {
      if (deleteData.deleteRIEVMedico.success) {
        toast.success("Se elimino correctamente la EV/RI.");
        setOpenDlg(false);
        setIdEliminacion(0);
        setIdEliminacionEvolucion(0);
        handleBuscar();
      } else {
        toast.error(deleteData.deleteRIEVMedico.error);
      }
    }
  });

  return (
    <>
      <div className='general'>
        <Grid
          container
          justifyContent="space-between"
          spacing={2}>
          <Grid size={{ xs: 12, md: 4, xl: 4 }}>
            <SelectInput
              options={delegaciones}
              label='Delegación'
              onChange={handleChange}
              value={dataCons?.delegacion}
              name='delegacion' />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 2 }}>
            <SelectInput
              options={meses}
              label='Mes'
              onChange={handleChange}
              value={dataCons?.mes}
              name='mes' />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 2 }}>
            <SelectInput
              options={anios}
              label='Año'
              onChange={handleChange}
              value={dataCons?.anio}
              name='anio' />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 2 }}>
            <SelectInput
              options={figurasMedico}
              label='Figura profesional'
              onChange={handleChange}
              value={dataCons?.figuraMedico}
              name='figuraMedico' />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 2 }}>
            <SelectInput
              options={digitalizaciones}
              label='Digitalizado'
              onChange={handleChange}
              value={dataCons?.digitalizado}
              name='digitalizado' />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 5 }}>
            <SelectInput
              options={profesionales}
              label='Profesional'
              onChange={handleChange}
              value={dataCons?.profesional}
              name='profesional'
              emptyOption={true} />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 5 }}>
            <SelectInput
              options={pacientes}
              label='Paciente'
              onChange={handleChange}
              value={dataCons?.paciente}
              name='paciente'
              emptyOption={true} />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 2 }}>
            <CustomButton
              className='custom-buttom-primary-color-2'
              onClick={handleBuscar}
              size='small'>

              Buscar
            </CustomButton>
          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 12 }}>
            <DataGridGenerico
              columns={columnsProcesamiento}
              rows={evaluaciones}
              fileNameExport='Evaluaciones RIEV'
              toolbar={false} />

          </Grid>
        </Grid>
      </div>

      <CustomDialog
        maxWidth="md"
        open={openDlg}
        title={'Eliminar EV/RI'}
        onCancel={() => { setOpenDlg(false); }}
        onAccept={handleAceptarDlg}
        acceptText="Aceptar">

        <strong>{textoEliminacion}</strong>
      </CustomDialog>
    </>);

}